import styled, { css } from 'styled-components';
import { theme } from 'styles';

export const R1SidebarMenuWrapper = styled.div<{ $collapsed: boolean }>`
  width: 100%;

  .ant5-menu-submenu-title,
  .ant5-menu-item {
    padding: 0 28px;
  }

  ${({ $collapsed }) =>
    $collapsed &&
    css`
      .ant5-menu-submenu-title {
        padding: 0 16px;
      }
    `}

  .ant5-menu-submenu-selected {
    background-color: ${theme.color.grey90};
  }
`;
